"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Diamond` instead */
export const Diamond = createSVGIcon(
  <>
    <path
      d="M17.974 3.021H6.026a1.71 1.71 0 0 0-1.396.719L1.642 7.923a1.714 1.714 0 0 0 .1 2.12l8.962 10.34a1.715 1.715 0 0 0 2.592 0l8.962-10.34a1.714 1.714 0 0 0 .1-2.12L19.37 3.74a1.72 1.72 0 0 0-1.397-.719Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m11.143 3.021-4 6.201L12 20.977M12.897 3.021l3.999 6.201L12 20.977M1.35 9.225H22.65"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Diamond",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
